import {StyleSheet} from 'react-native';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {stylePatterns} from '../../../../../../shared/theme/patterns';

const fl = StyleSheet.flatten;

export default () =>
  useStyles(({isDesktop, theme, mediaOnly}) => {
    return {
      file: {
        ...stylePatterns.flexCenterVertical,
        justifyContent: isDesktop ? 'flex-start' : 'space-between',
        marginBottom: 10,
        ...mediaOnly(DeviceSize.desktop, {width: 360}, {width: '100%'}),
        position: 'relative',
      },
      tooltipArrowStyle: {left: 20},
      tooltipContainerStyle: {left: 30, boxShadow: 'unset'},
      tooltipOverlayStyle: {backgroundColor: 'green', opacity: 0, display: 'flex', alignItems: 'flex-start'},
      tooltipModalStyle: {backgroundColor: theme.color.borderColor, height: 'auto'},
      fileTextContainer: {paddingRight: 20, flex: 1},
      fileText: fl([mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight)]),
      fileRemoveIcon: {
        width: 36,
        height: 36,
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.filePicker.removeFileIconColor,
      },
    };
  });
